/* import __COLOCATED_TEMPLATE__ from './screen-config-editor.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ScreenConfigEditorComponent extends Component
{
	@tracked screens = [];

	constructor()
	{
		super(...arguments);
		// Deep clone the initial config (array of screens)
		this.screens = JSON.parse(JSON.stringify(this.args.config || []));
	}

	@action addScreen()
	{
		// Find next available ID
		const maxId = this.screens.reduce((max, s) => Math.max(max, s.id || 0), 0);
		this.screens = [...this.screens, {
			id: maxId + 1,
			config: [[]]
		}];
	}

	@action removeScreen(screenIndex)
	{
		this.screens = this.screens.filter((_, i) => i !== screenIndex);
	}

	@action updateScreen(screenIndex, updatedScreen)
	{
		const newScreens = [...this.screens];
		newScreens[screenIndex] = updatedScreen;
		this.screens = newScreens;
	}

	@action downloadConfig()
	{
		const jsonString = JSON.stringify(this.screens, null, 2);
		const blob = new Blob([jsonString], { type: 'application/json' });
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'screenConfig.json';
		a.click();
		URL.revokeObjectURL(url);
	}
}
